<template>
  <el-dialog :visible.sync="dialogVisible" :title="title" :close-on-click-modal="false" class="move-down-dialog" width="20%">
    <span><i class="el-icon-warning icon-tip" />{{ message }}</span>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="click(2)">{{ button2 }}</el-button>
      <el-button type="primary" @click="click(1)">{{ button1 }}</el-button>
      <el-button @click="click(3)">{{ button3 }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      message: '',
      title: '',
      button1: '',
      button2: '',
      button3: ''
    }
  },
  methods: {
    openDialog(title, message, buttonName, onCancel) {
      this.title = title
      this.message = message
      this.onCancel = onCancel
      this.button1 = buttonName.button1
      this.button2 = buttonName.button2
      this.button3 = buttonName.button3
      this.dialogVisible = true
    },
    click(index) {
      if (typeof this.onCancel === 'function') {
        this.onCancel(index)
      }
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.move-down-dialog {
  margin-top: 20vh; /* 使用vh单位移动20个视窗高度 */
}
i{
  margin-right: 8px;
  color: orange;
  font-size: 15px;
}
</style>
